export interface IDynamicKeys {
  [key: string]: any;
}